import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletServiceSettingResponse } from '@/repositories/generated';

const response: WalletServiceSettingResponse = {
  prepaidSettlementDisplayType: 'HOUSE_AND_SMART_CODE',
  walletServiceSettingList: [
    {
      emailAuthInit: true,
      phoneAuthInit: true,
      walletServiceId: '001',
    },
    {
      emailAuthInit: true,
      phoneAuthInit: true,
      walletServiceId: '002',
    },
  ],
};

export const walletServiceSetting = http.get(
  createMockEndpoint('/wallet_service_setting'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
